webpackJsonp([1],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(424)
}
var Component = __webpack_require__(24)(
  /* script */
  __webpack_require__(171),
  /* template */
  __webpack_require__(1227),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 116:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return state; });
// Default State


var state = {
    currentId: 0
};

/***/ }),

/***/ 1218:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(24)(
  /* script */
  __webpack_require__(174),
  /* template */
  __webpack_require__(1228),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1219:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(24)(
  /* script */
  __webpack_require__(175),
  /* template */
  __webpack_require__(1232),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1220:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(24)(
  /* script */
  __webpack_require__(176),
  /* template */
  __webpack_require__(1231),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1221:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(24)(
  /* script */
  __webpack_require__(177),
  /* template */
  __webpack_require__(1233),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1222:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(24)(
  /* script */
  __webpack_require__(178),
  /* template */
  __webpack_require__(1229),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1223:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(24)(
  /* script */
  __webpack_require__(179),
  /* template */
  __webpack_require__(1235),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1224:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(24)(
  /* script */
  __webpack_require__(180),
  /* template */
  __webpack_require__(1226),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1225:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(24)(
  /* script */
  __webpack_require__(181),
  /* template */
  __webpack_require__(1230),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1226:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "header",
    attrs: {
      "id": "header"
    }
  }, [_c('div', {
    staticClass: "header-container"
  }, [_c('div', {
    staticClass: "header-login"
  }, [_c('a', {
    attrs: {
      "href": "/tt"
    }
  }, [_c('span', [_vm._v("\n                    Войти\n                ")]), _vm._v(" "), _c('GPlus')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "header-content"
  }, [_c('span', {
    staticClass: "header-content-txt"
  }, [_vm._v("Еще один таск трекер?")]), _vm._v(" "), _c('div', {
    staticClass: "header-content-logo"
  }, [_c('HeaderLogo')], 1), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('affix', {
    ref: "nav",
    staticClass: "navbar navbar-default",
    attrs: {
      "relative-element-selector": "#main",
      "offset": {
        top: 52,
        bottom: 0
      }
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_c('button', {
    staticClass: "navbar-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "collapse"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.openMenu = !_vm.openMenu
      }
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")]), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  })]), _vm._v(" "), _c('a', {
    staticClass: "navbar-brand",
    attrs: {
      "href": ""
    }
  }, [_c('HeaderLogo')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "collapse navbar-collapse",
    attrs: {
      "id": "navbar-collapse-1",
      "aria-expanded": _vm.openMenu ? true : false
    }
  }, [_c('scrollactive', {
    staticClass: "nav navbar-nav",
    attrs: {
      "active-class": "active",
      "offset": 200,
      "duration": 1000,
      "bezier-easing-value": ".5,0,.35,1"
    }
  }, [_c('li', {
    class: {
      collapsed: _vm.openMenu == false
    },
    attrs: {
      "data-toggle": "collapse",
      "aria-expanded": _vm.openMenu ? true : false
    }
  }, [_c('a', {
    staticClass: "scrollactive-item",
    attrs: {
      "href": "#header"
    }
  }, [_vm._v("Главная")])]), _vm._v(" "), _c('li', {
    class: {
      collapsed: _vm.openMenu == false
    },
    attrs: {
      "data-toggle": "collapse",
      "aria-expanded": _vm.openMenu ? true : false
    }
  }, [_c('a', {
    staticClass: "scrollactive-item",
    attrs: {
      "href": "#features"
    }
  }, [_vm._v("Преимущества")])]), _vm._v(" "), _c('li', {
    class: {
      collapsed: _vm.openMenu == false
    },
    attrs: {
      "data-toggle": "collapse",
      "aria-expanded": _vm.openMenu ? true : false
    }
  }, [_c('a', {
    staticClass: "scrollactive-item",
    attrs: {
      "href": "#overview"
    }
  }, [_vm._v("Возможности")])]), _vm._v(" "), _c('li', {
    class: {
      collapsed: _vm.openMenu == false
    },
    attrs: {
      "data-toggle": "collapse",
      "aria-expanded": _vm.openMenu ? true : false
    }
  }, [_c('a', {
    staticClass: "scrollactive-item",
    attrs: {
      "href": "#gallery"
    }
  }, [_vm._v("Галерея")])]), _vm._v(" "), _c('li', {
    class: {
      collapsed: _vm.openMenu == false
    },
    attrs: {
      "data-toggle": "collapse",
      "aria-expanded": _vm.openMenu ? true : false
    }
  }, [_c('a', {
    staticClass: "scrollactive-item",
    attrs: {
      "href": "#download"
    }
  }, [_vm._v("Подписаться")])]), _vm._v(" "), _c('li', {
    class: {
      collapsed: _vm.openMenu == false
    },
    attrs: {
      "data-toggle": "collapse",
      "aria-expanded": _vm.openMenu ? true : false
    }
  }, [_c('a', {
    staticClass: "scrollactive-item",
    attrs: {
      "href": "#donate"
    }
  }, [_vm._v("Поддержать")])]), _vm._v(" "), _c('li', {
    class: {
      collapsed: _vm.openMenu == false
    },
    attrs: {
      "data-toggle": "collapse",
      "aria-expanded": _vm.openMenu ? true : false
    }
  }, [_c('a', {
    staticClass: "scrollactive-item",
    attrs: {
      "href": "#contact"
    }
  }, [_vm._v("Контакты")])])]), _vm._v(" "), _c('div', {
    staticClass: "header-lang"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("EN")]), _vm._v(" "), _c('a', {
    staticClass: "active",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("RU")])])], 1)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "header-content-txt"
  }, [_vm._v("Да, и возможности — "), _c('span', [_vm._v("огонь!")])])
}]}

/***/ }),

/***/ 1227:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    class: _vm.klass,
    style: (_vm.style),
    attrs: {
      "version": "1.1",
      "role": _vm.label ? 'img' : 'presentation',
      "aria-label": _vm.label,
      "x": _vm.x,
      "y": _vm.y,
      "width": _vm.width,
      "height": _vm.height,
      "viewBox": _vm.box
    }
  }, [_vm._t("default", [(_vm.icon && _vm.icon.paths) ? _vm._l((_vm.icon.paths), function(path, i) {
    return _c('path', _vm._b({
      key: ("path-" + i)
    }, 'path', path, false))
  }) : _vm._e(), _vm._v(" "), (_vm.icon && _vm.icon.polygons) ? _vm._l((_vm.icon.polygons), function(polygon, i) {
    return _c('polygon', _vm._b({
      key: ("polygon-" + i)
    }, 'polygon', polygon, false))
  }) : _vm._e(), _vm._v("\b\n    "), (_vm.icon && _vm.icon.raw) ? [_c('g', {
    domProps: {
      "innerHTML": _vm._s(_vm.raw)
    }
  })] : _vm._e()])], 2)
},staticRenderFns: []}

/***/ }),

/***/ 1228:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "features",
    attrs: {
      "id": "features"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "r1 row animateblock btt speed-1"
  }, [_c('slick', {
    staticClass: "c1 col-md-12",
    attrs: {
      "id": "features-carousel-1",
      "options": _vm.slickOptions
    }
  }, [_c('a', {
    staticClass: "features-wrapper",
    attrs: {
      "href": "#"
    }
  }, [_c('div', {
    staticClass: "features-icon universal"
  }, [_c('span', {
    staticClass: "icon_genius"
  }, [_c('Atom')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "features-content"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Универсально")]), _vm._v(" "), _c('p', {
    staticClass: "description"
  }, [_vm._v("\n                            Гибкие возможности менять режимы отображения в зависимости от ваших целей. Доски, списки, таблицы, календари, диаграммы. Выбираете в пару кликов любой удобный вид для тех или иных работ.\n                        ")])])]), _vm._v(" "), _c('a', {
    staticClass: "features-wrapper",
    attrs: {
      "href": "#"
    }
  }, [_c('div', {
    staticClass: "features-icon fast"
  }, [_c('span', {
    staticClass: "icon_map_alt"
  }, [_c('Racing')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "features-content"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Быстро")]), _vm._v(" "), _c('p', {
    staticClass: "description"
  }, [_vm._v("\n                            Ускоряем работу с задачами в разы. Повышаем эффективность управления проектом. Вы тратите минимум времени на ведение проекта и максимум на сам проект.\n                        ")])])]), _vm._v(" "), _c('a', {
    staticClass: "features-wrapper",
    attrs: {
      "href": "#"
    }
  }, [_c('div', {
    staticClass: "features-icon visually"
  }, [_c('span', {
    staticClass: "ion-android-globe"
  }, [_c('ReadingGlasses')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "features-content"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Наглядно")]), _vm._v(" "), _c('p', {
    staticClass: "description"
  }, [_vm._v("\n                            Всегда видна цельная картина по проекту. Кто чем занят, что сделано, что в работе, что в планах. Наглядные быстрые срезы по статусу любого проекта\n                        ")])])]), _vm._v(" "), _c('a', {
    staticClass: "features-wrapper",
    attrs: {
      "href": "#"
    }
  }, [_c('div', {
    staticClass: "features-icon multitasking"
  }, [_c('span', {
    staticClass: "icon_gift_alt"
  }, [_c('Analytics')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "features-content"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Многозадачность")]), _vm._v(" "), _c('p', {
    staticClass: "description"
  }, [_vm._v("\n                            Возможность в несколько кликов создать сразу много задач на всю команду, независимо от того в каком виде и откуда вы получили задачи. Действия одновременно с несколькими задачами.\n                        ")])])]), _vm._v(" "), _c('a', {
    staticClass: "features-wrapper",
    attrs: {
      "href": "#"
    }
  }, [_c('div', {
    staticClass: "features-icon notifications"
  }, [_c('span', {
    staticClass: "icon_genius"
  }, [_c('Chat')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "features-content"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Уведомления")]), _vm._v(" "), _c('p', {
    staticClass: "description"
  }, [_vm._v("\n                            Продуманная политика уведомлений, широкие возможности настроек. Всё что нужно, чтобы уведомления не были назойливыми, а по-настоящему полезными и эффективными\n                        ")])])]), _vm._v(" "), _c('a', {
    staticClass: "features-wrapper",
    attrs: {
      "href": "#"
    }
  }, [_c('div', {
    staticClass: "features-icon customization"
  }, [_c('span', {
    staticClass: "icon_map_alt"
  }, [_c('Settings')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "features-content"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Настраиваемость")]), _vm._v(" "), _c('p', {
    staticClass: "description"
  }, [_vm._v("\n                            Огромное количество настроек системы под себя. Никто лучше вас не знает специфику вашей работы. Наша политика — не навязывать свои привычки, а сделать инструмент максимально подходящий под ваши процессы.\n                        ")])])])])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-header"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("Ключевые преимущества")]), _vm._v(" "), _c('h3', {
    staticClass: "section-subtitle"
  }, [_vm._v("\n                Разбираем задачи как "), _c('span', [_vm._v("горячие")]), _vm._v(" пирожки")])])
}]}

/***/ }),

/***/ 1229:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer-top"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-3 footer-lg"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('FooterLogo')], 1)]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)])])]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12 col-md-5 footer-menu"
  }, [_c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Главная")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Преимущества")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Возможности")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Галерея")])])]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Подписаться")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Поддержать")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Котакты")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12 col-md-4 footer-social"
  }, [_c('div', {
    staticClass: "footer-social-title"
  }, [_vm._v("\n                        Мы в соцсетях\n                    ")]), _vm._v(" "), _c('section', {
    staticClass: "social-icons"
  }, [_c('h3', {
    staticClass: "hide"
  }, [_vm._v("Social Buttons")]), _vm._v(" "), _c('a', {
    staticClass: "btn-social facebook",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "top",
      "title": "Facebook",
      "href": "#",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "fa fa-facebook"
  })]), _vm._v(" "), _c('a', {
    staticClass: "btn-social twitter",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "top",
      "title": "Twitter",
      "href": "#",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "fa fa-twitter"
  })]), _vm._v(" "), _c('a', {
    staticClass: "btn-social google-plus",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "top",
      "title": "Google+",
      "href": "#",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "fa fa-google-plus"
  })]), _vm._v(" "), _c('a', {
    staticClass: "btn-social youtube",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "top",
      "title": "Youtube",
      "href": "#",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "fa fa-youtube"
  })]), _vm._v(" "), _c('a', {
    staticClass: "btn-social instagram",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "top",
      "title": "Instagram",
      "href": "#",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "fa fa-instagram"
  })]), _vm._v(" "), _c('a', {
    staticClass: "btn-social email",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "top",
      "title": "Email",
      "href": "#",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "fa fa-envelope"
  })]), _vm._v(" "), _c('a', {
    staticClass: "btn-social rss",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "top",
      "title": "RSS",
      "href": "#",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "fa fa-rss"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-bottom"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('span', {
    staticClass: "col-xs-12 footer-copyright"
  }, [_vm._v("© 2018 — Hottt. All rights reserved.")])])])])
}]}

/***/ }),

/***/ 1230:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "overview",
    attrs: {
      "id": "overview"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "r1 row"
  }, [_c('div', {
    staticClass: "c1 col-md-12"
  }, [_c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane fade in active",
    attrs: {
      "id": "overview-tab-2"
    }
  }, [_c('div', {
    staticClass: "r1 row"
  }, [_c('div', {
    staticClass: "c2 col-sm-6 col-md-6 animateblock ltr-2 speed-3"
  }, [_c('div', {
    staticClass: "overview-wrapper"
  }, [_c('div', {
    staticClass: "hidden-sm overview-icon ico-1"
  }, [_c('User')], 1), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "overview-wrapper"
  }, [_c('div', {
    staticClass: "hidden-sm overview-icon ico-2"
  }, [_c('File')], 1), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "overview-wrapper"
  }, [_c('div', {
    staticClass: "hidden-sm overview-icon ico-3"
  }, [_c('Chat')], 1), _vm._v(" "), _vm._m(3)])]), _vm._v(" "), _c('div', {
    staticClass: "c3 col-sm-6 col-md-6 animateblock rtl-2 speed-3"
  }, [_c('div', {
    staticClass: "overview-wrapper"
  }, [_c('div', {
    staticClass: "hidden-sm overview-icon ico-4"
  }, [_c('Block')], 1), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _c('div', {
    staticClass: "overview-wrapper"
  }, [_c('div', {
    staticClass: "hidden-sm overview-icon ico-5"
  }, [_c('Doc')], 1), _vm._v(" "), _vm._m(5)]), _vm._v(" "), _c('div', {
    staticClass: "overview-wrapper"
  }, [_c('div', {
    staticClass: "hidden-sm overview-icon ico-6"
  }, [_c('Search')], 1), _vm._v(" "), _vm._m(6)])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-header"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("Возможности")]), _vm._v(" "), _c('h3', {
    staticClass: "section-subtitle"
  }, [_vm._v("\n                Плюс ко всему у нас есть весь стандартный набор функций")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "overview-content"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Вид для клиента")]), _vm._v(" "), _c('p', {
    staticClass: "description"
  }, [_vm._v("\n                                            У нас предусмотрена возможность организовать вход для клиентов в конкретные проекты, для показа процесса работы и статуса задач. Только то что вы хотите показывать, без вмешательства клиента в ваши внутренние процессы.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "overview-content"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Логирование ")]), _vm._v(" "), _c('p', {
    staticClass: "description"
  }, [_vm._v("\n                                            Ведем историю всех действий всех пользователей по задачам и таскам. Всегда легко найти когда, что и кем было сделано по проекту.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "overview-content"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Комментарии")]), _vm._v(" "), _c('p', {
    staticClass: "description"
  }, [_vm._v("\n                                            Что-то непонятно по задаче и нужно уточнить? Удобное обсуждение задач прямо в теле задачи. ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "overview-content"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Безопасность")]), _vm._v(" "), _c('p', {
    staticClass: "description"
  }, [_vm._v("\n                                            Используем SSL, SHA256 шифрование и шифрование БД, так что никто кроме вас не получит доступа к вашим данным.\n                                            Возможность назначить разный набор прав разным группам и индивидуально пользователям")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "overview-content"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Файлы")]), _vm._v(" "), _c('p', {
    staticClass: "description"
  }, [_vm._v("\n                                            Возможность прикреплять файлы как для хранения в облаке самого трекера, так и указывать внешние ссылки. Доступ к файлам как приватный так и общий.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "overview-content"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Поиск")]), _vm._v(" "), _c('p', {
    staticClass: "description"
  }, [_vm._v("\n                                            Умный контекстный поиск с набором настроек для получения точного результата")])])
}]}

/***/ }),

/***/ 1231:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact",
    attrs: {
      "id": "contact"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "section-header"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("Контакты")]), _vm._v(" "), _c('h3', {
    staticClass: "section-subtitle"
  }, [_vm._v("\n                    Остались вопросы? "), _c('br'), _vm._v("\n                    Свяжитесь с нами, сделаем все что в наших силах\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 animateblock btt speed-1"
  }, [_c('form', {
    staticClass: "contact-form"
  }, [_c('div', {
    staticClass: "contact-form-box form-group"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Имя"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "contact-form-box form-group"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "placeholder": "Email"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "contact-form-box msg form-group"
  }, [_c('textarea', {
    staticClass: "form-control",
    attrs: {
      "name": "message",
      "placeholder": "Сообщение"
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n                        Отправить\n                    ")])])])])])])
}]}

/***/ }),

/***/ 1232:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "calltoaction",
    attrs: {
      "id": "download"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "section-header"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("Подписка")]), _vm._v(" "), _c('h3', {
    staticClass: "section-subtitle"
  }, [_vm._v("\n                Проект на стадии разработки. "), _c('br'), _vm._v("\n                Мы можем вас уведомить, "), _c('br'), _vm._v("\n                когда будут запущены тестовые релизы\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "r1 row"
  }, [_c('div', {
    staticClass: "c1 col-md-12"
  }, [_c('div', {
    staticClass: "newsletter-wrapper animateblock rtl-2 speed-1"
  }, [_c('h3', [_vm._v("Заинтересовало? "), _c('br'), _vm._v("\n                        Подпишись на уведомления:")]), _vm._v(" "), _c('form', {
    staticClass: "form-inline subscription-mailchimp"
  }, [_c('div', {
    staticClass: "form-group input-group input-newsletter"
  }, [_c('label', {
    staticClass: "sr-only",
    attrs: {
      "for": "newsletter-email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "newsletter-email",
      "type": "email",
      "placeholder": "Email"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Подписаться")])])]), _vm._v(" "), _c('small', {
    staticClass: "help-block"
  }, [_vm._v("Обещаем не спамить. Только важное")])]), _vm._v(" "), _c('div', {
    staticClass: "alerts alerts-newsletter"
  })])])])])])
}]}

/***/ }),

/***/ 1233:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "donate",
    attrs: {
      "id": "donate"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "section-header"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("Поддержать")]), _vm._v(" "), _c('h3', {
    staticClass: "section-subtitle"
  }, [_vm._v("\n                    А мы вам за это инвайт, когда состоится релиз. "), _c('br'), _vm._v("\n                    Бета-тестовый вход, скидки и всякие плюшки когда запустимся.\n\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 donate-content animateblock btt speed-1"
  }, [_c('div', {
    staticClass: "col-md-6 box"
  }, [_c('img', {
    attrs: {
      "src": "landing/static/images/donate_img_1.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 box"
  }, [_c('img', {
    attrs: {
      "src": "landing/static/images/donate_img_2.png",
      "alt": ""
    }
  })])])])])])
}]}

/***/ }),

/***/ 1234:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 1235:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "gallery",
    attrs: {
      "id": "gallery"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "r1 row animateblock btt speed-1"
  }, [_c('slick', {
    staticClass: "c1 col-md-12",
    attrs: {
      "id": "gallery-carousel-1",
      "options": _vm.slickOptions
    }
  }, [_c('div', {
    staticClass: "link-modal"
  }, [_c('img', {
    staticClass: "img-responsive thumb",
    attrs: {
      "src": "landing/static/images/gallery/gallery_item_1.png",
      "alt": "Screenshot 1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "link-modal"
  }, [_c('img', {
    staticClass: "img-responsive thumb",
    attrs: {
      "src": "landing/static/images/gallery/gallery_item_1.png",
      "alt": "Screenshot 2"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "link-modal"
  }, [_c('img', {
    staticClass: "img-responsive thumb",
    attrs: {
      "src": "landing/static/images/gallery/gallery_item_1.png",
      "alt": "Screenshot 3"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "link-modal"
  }, [_c('img', {
    staticClass: "img-responsive thumb",
    attrs: {
      "src": "landing/static/images/gallery/gallery_item_1.png",
      "alt": "Screenshot 1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "link-modal"
  }, [_c('img', {
    staticClass: "img-responsive thumb",
    attrs: {
      "src": "landing/static/images/gallery/gallery_item_1.png",
      "alt": "Screenshot 2"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "link-modal"
  }, [_c('img', {
    staticClass: "img-responsive thumb",
    attrs: {
      "src": "landing/static/images/gallery/gallery_item_1.png",
      "alt": "Screenshot 3"
    }
  })])])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-header"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("Галерея")]), _vm._v(" "), _c('h3', {
    staticClass: "section-subtitle"
  }, [_vm._v("Современный удобный дизайн адаптированный под все распространенные устройства")])])
}]}

/***/ }),

/***/ 1236:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-layout",
    attrs: {
      "id": "app"
    }
  }, [_c('Header'), _vm._v(" "), _c('div', {
    staticClass: "main",
    attrs: {
      "id": "main"
    }
  }, [_c('Advantages'), _vm._v(" "), _c('Overview'), _vm._v(" "), _c('Gallery'), _vm._v(" "), _c('CallToAction'), _vm._v(" "), _c('Donate'), _vm._v(" "), _c('Contacts'), _vm._v(" "), _c('Footer')], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1240:
/***/ (function(module, exports) {

module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 54.304 54.304"><path d="M47.838 17.132H36.202V8.728c0-3.556-2.909-6.465-6.465-6.465H6.465C2.909 2.264 0 5.173 0 8.728v27.151l7.758-6.465h8.404v9.697c0 3.556 2.909 6.465 6.465 6.465h23.919l7.758 6.465V23.597c-.001-3.556-2.91-6.465-6.466-6.465zm-19.07 21.98a2.262 2.262 0 1 1 0-4.526 2.263 2.263 0 0 1 0 4.526zm-6.141-21.98c-3.556 0-6.465 2.909-6.465 6.465v1.293H6.119L4.86 25.939l-.336.279V8.728c0-1.051.888-1.939 1.939-1.939h23.273c1.051 0 1.939.888 1.939 1.939v8.404h-9.048zm12.605 21.98a2.262 2.262 0 1 1 0-4.526 2.263 2.263 0 0 1 0 4.526zm6.465 0a2.262 2.262 0 1 1 0-4.526 2.263 2.263 0 1 1 0 4.526z"/></svg>'};

/***/ }),

/***/ 1241:
/***/ (function(module, exports) {

module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 55.473 55.473"><path d="M50.196 40.286a25.414 25.414 0 0 0 2.198-10.349 25.413 25.413 0 0 0-4.693-14.752 25.604 25.604 0 0 0-11.995-9.202l-1.568 4.245a21.074 21.074 0 0 1 9.872 7.577 20.897 20.897 0 0 1 3.859 12.134 20.935 20.935 0 0 1-1.537 7.89l-4.184-2.661 1.143 11.454 10.857-3.82-3.952-2.516zM39.26 46.895a20.915 20.915 0 0 1-12.401 4.053 20.9 20.9 0 0 1-10.399-2.749 21.12 21.12 0 0 1-5.711-4.788l4.075-2.303L4.18 36.729 2.444 48.107l4.311-2.437a25.656 25.656 0 0 0 7.463 6.459 25.425 25.425 0 0 0 12.642 3.344 25.437 25.437 0 0 0 15.076-4.928l-2.676-3.65zM22.593 0l.037 4.758a25.48 25.48 0 0 0-13.827 7.124 25.459 25.459 0 0 0-7.206 21.727l4.48-.645a20.93 20.93 0 0 1 5.927-17.883 20.965 20.965 0 0 1 10.663-5.735l.038 4.874L31.7 7.04 22.593 0z"/><path d="M17.959 18.948v21.98H36.06v-21.98H17.959zm9.697 13.898h-5.818v-3.232h5.818v3.232zm4.525-6.464H21.838V23.15h10.343v3.232z"/></svg>'};

/***/ }),

/***/ 1242:
/***/ (function(module, exports) {

module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52.041 52.041"><path d="M43.151 22.95v-6.602c.002-4.544-1.955-8.666-5.062-11.602C34.984 1.802 30.709 0 26.021 0c-4.689 0-8.964 1.802-12.069 4.746-3.107 2.936-5.064 7.058-5.062 11.602v6.602H4.04v22.626c0 3.556 2.909 6.465 6.465 6.465h31.03c3.556 0 6.465-2.909 6.465-6.465V22.95h-4.849zM27.636 38.016v4.327h-3.232v-4.327a3.22 3.22 0 0 1-1.616-2.784 3.231 3.231 0 1 1 6.464 0 3.215 3.215 0 0 1-1.616 2.784zm10.99-15.066H13.414v-6.602c.002-3.235 1.374-6.156 3.649-8.317 2.276-2.155 5.435-3.505 8.957-3.505 3.522 0 6.682 1.35 8.957 3.505 2.275 2.162 3.647 5.083 3.649 8.317v6.602z"/></svg>'};

/***/ }),

/***/ 1243:
/***/ (function(module, exports) {

module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50.8 50.8"><path d="M38.3 33.3c2.3-3.4 3.7-7.5 3.7-11.9 0-11.6-9.4-21-21-21S0 9.8 0 21.4s9.4 21 21 21c4.8 0 9.3-1.6 12.9-4.4l12.3 12.3 4.6-4.6-12.5-12.4zM21 39.2c-9.8 0-17.8-8-17.8-17.8S11.2 3.6 21 3.6s17.8 8 17.8 17.8-8 17.8-17.8 17.8z"/></svg>'};

/***/ }),

/***/ 1244:
/***/ (function(module, exports) {

module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50.425 50.425"><path d="M41.05 40.081a3.236 3.236 0 0 0-3.232 3.232v7.111l10.343-10.343H41.05z"/><path d="M11.313 6.465V43.96c0 3.556 2.909 6.465 6.465 6.465h16.808v-7.111c0-3.556 2.909-6.465 6.465-6.465h7.111l.001-30.384h-36.85zm19.393 26.181H19.07v-3.232h11.636v3.232zm9.698-7.757H19.07v-3.232h21.333v3.232zm0-7.758H19.07v-3.232h21.333v3.232z"/><path d="M2.263 0v37.495c0 3.337 2.563 6.105 5.818 6.432V3.232h31.032V0H2.263z"/></svg>'};

/***/ }),

/***/ 1245:
/***/ (function(module, exports) {

module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 197.2 197.2"><path class="analytic-obj-1" d="M182.846 101.088H21.349v-7.9h161.497z"/><path class="analytic-obj-1" d="M179.311 102.462H17.814v-7.9h161.497z"/><path class="analytic-obj-1" d="M102.583 179.29h-7.9V17.793h7.9z"/><path class="analytic-obj-1" d="M106.078 177.815h-7.9V16.32h7.9z"/><g><circle class="analytic-obj-1" cx="155.7" cy="41.5" r="17.8"/><circle class="analytic-obj-2" cx="98.6" cy="98.6" r="30.8"/><circle class="analytic-obj-2" cx="179.4" cy="98.6" r="17.8"/><circle class="analytic-obj-2" cx="17.8" cy="98.6" r="17.8"/><circle class="analytic-obj-2" cx="98.6" cy="179.4" r="17.8"/><circle class="analytic-obj-2" cx="98.6" cy="17.8" r="17.8"/><circle class="analytic-obj-1" cx="155.7" cy="155.7" r="17.8"/><circle class="analytic-obj-1" cx="41.5" cy="41.5" r="17.8"/><circle class="analytic-obj-1" cx="41.5" cy="155.7" r="17.8"/></g></svg>'};

/***/ }),

/***/ 1246:
/***/ (function(module, exports) {

module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 456.1"><path class="atom-path-1" d="M503.8 236.2c-4.5 0-8.2-3.7-8.2-8.2 0-42.1-96.3-87.1-239.7-87.1S16.3 186 16.3 228.1c0 4.5-3.7 8.2-8.2 8.2S0 232.6 0 228.1c0-29.1 27.6-55.7 77.8-75 47.7-18.4 111-28.5 178.2-28.5s130.5 10.1 178.2 28.5c50.2 19.3 77.8 45.9 77.8 75 0 4.5-3.7 8.1-8.2 8.1z"/><path class="atom-path-1" d="M132.1 450.9c-1.4 0-2.8-.4-4.1-1.1-25.2-14.5-34.4-51.8-26.1-104.9 8-50.5 30.8-110.4 64.4-168.5 33.6-58.2 74-107.9 113.7-140.1C321.9 2.4 358.8-8.2 384 6.4c3.9 2.3 5.2 7.3 3 11.2-2.3 3.9-7.3 5.2-11.2 3-36.4-21-123.6 39.8-195.3 164-71.7 124.2-80.8 230.1-44.4 251.1 3.9 2.3 5.2 7.3 3 11.2-1.5 2.5-4.2 4-7 4z"/><path class="atom-path-1" d="M359.1 456.1c-22.3 0-49.4-12.3-79-36.2-39.7-32.2-80.1-81.9-113.7-140.1s-56.5-118-64.4-168.5c-8.4-53.2.8-90.4 26-104.9 3.9-2.3 8.9-.9 11.2 3 2.3 3.9.9 8.9-3 11.2-18.6 10.8-25.2 42.9-18.1 88.2 7.7 48.6 29.8 106.4 62.4 162.9 62.3 108 136.4 168.1 178.6 168.1 6.3 0 11.9-1.3 16.7-4.1 3.9-2.3 8.9-.9 11.2 3 2.3 3.9.9 8.9-3 11.2-7.4 4.1-15.7 6.2-24.9 6.2z"/><path class="atom-path-1" d="M256 331.5c-67.2 0-130.5-10.1-178.2-28.5C27.6 283.8 0 257.1 0 228.1c0-4.5 3.7-8.2 8.2-8.2s8.2 3.7 8.2 8.2c0 42.1 96.3 87.1 239.7 87.1s239.7-45.1 239.7-87.1c0-4.5 3.7-8.2 8.2-8.2s8.2 3.7 8.2 8.2c0 29.1-27.6 55.7-77.8 75-47.9 18.3-111.2 28.4-178.4 28.4z"/><circle class="atom-path-2" cx="53.8" cy="173.6" r="21.8"/><circle class="atom-path-2" cx="310.4" cy="431.5" r="21.8"/><circle class="atom-path-2" cx="107.1" cy="79.4" r="21.8"/><circle class="atom-path-2" cx="256" cy="228.1" r="49"/><path class="atom-path-1" d="M152.9 456.1c-9.2 0-17.6-2.1-24.9-6.4-3.9-2.3-5.2-7.3-3-11.2 2.3-3.9 7.3-5.2 11.2-3 36.4 21 123.6-39.8 195.3-164 32.6-56.5 54.8-114.3 62.4-162.9 7.1-45.3.6-77.5-18.1-88.2-3.9-2.3-5.2-7.3-3-11.2 2.3-3.9 7.3-5.2 11.2-3 25.2 14.5 34.4 51.8 26.1 104.9-8 50.5-30.8 110.4-64.4 168.5s-74 107.9-113.7 140.1c-29.7 24.1-56.8 36.4-79.1 36.4z"/><path class="atom-path-1" d="M379.9 450.9c-2.8 0-5.6-1.5-7.1-4.1-2.3-3.9-.9-8.9 3-11.2 36.4-21 27.3-127-44.4-251.1S172.5-.5 136.1 20.5c-3.9 2.3-8.9.9-11.2-3-2.3-3.9-.9-8.9 3-11.2C153.1-8.2 190 2.4 231.8 36.2c39.8 32.2 80.1 81.9 113.7 140.1 33.6 58.2 56.5 118 64.4 168.5 8.4 53.1-.9 90.4-26.1 104.9-1.1.8-2.5 1.2-3.9 1.2z"/><circle class="atom-path-2" cx="404.9" cy="79.4" r="21.8"/></svg>'};

/***/ }),

/***/ 1247:
/***/ (function(module, exports) {

module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 488.7 465.5"><path class="chat-obj-1" d="M139.6 139.6c-12.8 0-23.3 10.5-23.3 23.3V448c0 9.3 8.1 17.5 17.5 17.5 3.5 0 7-1.2 10.5-3.5l75.6-57c8.1-5.8 17.5-9.3 27.9-9.3h217.6c12.8 0 23.3-10.5 23.3-23.3V162.9c0-12.8-10.5-23.3-23.3-23.3H139.6z"/><path class="chat-obj-2" d="M465.5 139.6v221.1c0 7-4.7 11.6-11.6 11.6H224.6c-10.5 0-19.8 3.5-27.9 9.3l-75.6 57c-1.2 1.2-3.5 2.3-4.7 2.3v7c0 9.3 8.1 17.5 17.5 17.5 3.5 0 7-1.2 10.5-3.5l75.6-57c8.1-5.8 17.5-9.3 27.9-9.3h217.6c12.8 0 23.3-10.5 23.3-23.3V162.9c-.1-12.8-10.5-23.3-23.3-23.3z"/><circle class="chat-obj-3" cx="302.5" cy="267.6" r="23.3"/><circle class="chat-obj-3" cx="384" cy="267.6" r="23.3"/><circle class="chat-obj-3" cx="221.1" cy="267.6" r="23.3"/><path class="chat-obj-4" d="M393.3 246.7c1.2 3.5 2.3 5.8 2.3 9.3 0 12.8-10.5 23.3-23.3 23.3-3.5 0-7-1.2-9.3-2.3 3.5 8.1 11.6 14 20.9 14 12.8 0 23.3-10.5 23.3-23.3.1-9.4-5.7-17.5-13.9-21zM311.9 246.7c1.2 3.5 2.3 5.8 2.3 9.3 0 12.8-10.5 23.3-23.3 23.3-3.5 0-7-1.2-9.3-2.3 3.5 8.1 11.6 14 20.9 14 12.8 0 23.3-10.5 23.3-23.3 0-9.4-5.8-17.5-13.9-21zM230.4 246.7c1.2 3.5 2.3 5.8 2.3 9.3 0 12.8-10.5 23.3-23.3 23.3-3.5 0-7-1.2-9.3-2.3 3.5 8.1 11.6 14 20.9 14 12.8 0 23.3-10.5 23.3-23.3.1-9.4-5.8-17.5-13.9-21z"/><path class="chat-obj-2" d="M232.7 209.5h-17.5l5.8-69.8h23.3v58.2c.1 6.9-4.6 11.6-11.6 11.6z"/><path class="chat-obj-5" d="M0 23.3v116.4C0 152.5 10.5 163 23.3 163h102.4c9.3 0 18.6 2.3 25.6 8.1l53.5 36.1c3.5 2.3 5.8 3.5 10.5 3.5 9.3 0 17.5-8.1 17.5-17.5V23.3c0-12.8-10.5-23.3-23.3-23.3H23.3C10.5 0 0 10.5 0 23.3z"/><path class="chat-obj-6" d="M209.5 0v157.1c0 9.3-8.1 17.5-17.5 17.5-3.5 0-7-1.2-10.5-3.5l-32.6-24.4c-5.8-4.7-14-7-20.9-7H0C0 152.5 10.5 163 23.3 163h102.4c9.3 0 18.6 2.3 25.6 8.1l53.5 36.1c3.5 2.3 5.8 3.5 10.5 3.5 9.3 0 17.5-8.1 17.5-17.5V23.3C232.7 10.5 222.3 0 209.5 0z"/><g><circle class="chat-obj-3" cx="116.4" cy="81.5" r="11.6"/><circle class="chat-obj-3" cx="69.8" cy="81.5" r="11.6"/><circle class="chat-obj-3" cx="162.9" cy="81.5" r="11.6"/></g></svg>'};

/***/ }),

/***/ 1248:
/***/ (function(module, exports) {

module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="66" height="66" viewBox="0 0 66 66"><defs><path id="a" d="M1208 40a32 32 0 1 1 0 64 32 32 0 0 1 0-64z"/><path id="b" d="M1214.89 70.03c1.02 7.19-2.06 17.97-14.64 17.97A15.12 15.12 0 0 1 1185 73c0-8.28 6.83-15 15.25-15 3.95 0 7.55 1.48 10.25 3.9-3.19 2.97-3.08 3.14-4.34 4.38a8.72 8.72 0 0 0-5.91-2.2c-5 0-8.91 4-8.91 8.92s3.9 8.91 8.9 8.91c4.95 0 6.96-2.1 8.25-5.95l-8.24.01v-5.94h14.64zm3.62 4.01v-3.71h5.43v-5.2h3.78v5.2h5.28v3.71h-5.28v5.35h-3.78v-5.35z"/></defs><use fill="#ff6a64" xlink:href="#a" transform="translate(-1175 -39)"/><use fill="#fff" xlink:href="#b" transform="translate(-1175 -39)"/></svg>'};

/***/ }),

/***/ 1249:
/***/ (function(module, exports) {

module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 406.1 512"><path class="racing-obj-1" d="M314.4 150.4l-14.9-9.5 26.2-41.2 14.9 9.5z"/><path class="racing-obj-2" d="M349.1 119.8l4.7-7.5c2.6-4.1 1.4-9.6-2.7-12.2l-21.6-13.8c-4.1-2.6-9.6-1.4-12.2 2.7l-4.7 7.5c-2.6 4.1-1.4 9.6 2.7 12.2l21.6 13.8c4.1 2.7 9.5 1.4 12.2-2.7z"/><path class="racing-obj-1" d="M91.6 150.4l-26.1-41.2 14.9-9.5 26.1 41.2z"/><path class="racing-obj-2" d="M203 105.9c-29.2 0-53-23.8-53-53s23.8-53 53-53 53 23.8 53 53-23.8 53-53 53zm0-88.2c-19.5 0-35.3 15.8-35.3 35.3s15.8 35.3 35.3 35.3 35.3-15.8 35.3-35.3-15.8-35.3-35.3-35.3z"/><path class="racing-obj-1" d="M194.2 61.8h17.7v53h-17.7z"/><path class="racing-obj-2" d="M216.3 70.6h-26.5c-4.9 0-8.8-4-8.8-8.8V53c0-4.9 4-8.8 8.8-8.8h26.5c4.9 0 8.8 4 8.8 8.8v8.8c0 4.9-4 8.8-8.8 8.8zM203 105.9C90.9 105.9 0 196.8 0 309s90.9 203 203 203 203-90.9 203-203-90.8-203.1-203-203.1zm0 370.8c-92.6 0-167.7-75.1-167.7-167.7S110.4 141.2 203 141.2 370.8 216.3 370.8 309 295.7 476.7 203 476.7z"/><path class="racing-obj-1" d="M203 123.6c-102.4 0-185.4 83-185.4 185.4s83 185.4 185.4 185.4 185.4-83 185.4-185.4-83-185.4-185.4-185.4zm0 353.1c-92.6 0-167.7-75.1-167.7-167.7S110.4 141.2 203 141.2 370.8 216.3 370.8 309 295.7 476.7 203 476.7z"/><path class="racing-obj-3" d="M296.7 402.6c24-24 38.8-57.1 38.8-93.6 0-73.1-59.3-132.4-132.4-132.4V309l93.6 93.6z"/><path class="racing-obj-2" d="M57 119.8l-4.7-7.5c-2.6-4.1-1.4-9.6 2.7-12.2l21.6-13.8c4.1-2.6 9.6-1.4 12.2 2.7l4.7 7.5c2.6 4.1 1.4 9.6-2.7 12.2l-21.6 13.8c-4.1 2.7-9.6 1.4-12.2-2.7z"/><path class="racing-obj-1" d="M203 158.9c-4.9 0-8.8 4-8.8 8.8v17.7c0 4.9 4 8.8 8.8 8.8 4.9 0 8.8-4 8.8-8.8v-17.7c.1-4.9-3.9-8.8-8.8-8.8zM203 423.7c-4.9 0-8.8 4-8.8 8.8v17.7c0 4.9 4 8.8 8.8 8.8 4.9 0 8.8-4 8.8-8.8v-17.7c.1-4.8-3.9-8.8-8.8-8.8zM353.1 309c0-4.9-4-8.8-8.8-8.8h-17.7c-4.9 0-8.8 4-8.8 8.8 0 4.9 4 8.8 8.8 8.8h17.7c4.8 0 8.8-4 8.8-8.8zM88.3 309c0-4.9-4-8.8-8.8-8.8H61.8c-4.9 0-8.8 4-8.8 8.8 0 4.9 4 8.8 8.8 8.8h17.7c4.8 0 8.8-4 8.8-8.8z"/><g><path class="racing-obj-2" d="M128 438.9c4.2 2.4 9.6 1 12.1-3.2l8.8-15.3c2.4-4.2 1-9.6-3.2-12.1-4.2-2.4-9.6-1-12.1 3.2l-8.8 15.3c-2.5 4.3-1 9.7 3.2 12.1zM260.4 209.6c4.2 2.4 9.6 1 12.1-3.2l8.8-15.3c2.4-4.2 1-9.6-3.2-12.1-4.2-2.4-9.6-1-12.1 3.2l-8.8 15.3c-2.5 4.2-1 9.6 3.2 12.1zM73.1 233.9c-2.4 4.2-1 9.6 3.2 12.1l15.3 8.8c4.2 2.4 9.6 1 12.1-3.2 2.4-4.2 1-9.6-3.2-12.1l-15.3-8.8c-4.3-2.4-9.7-1-12.1 3.2zM302.4 366.3c-2.4 4.2-1 9.6 3.2 12.1l15.3 8.8c4.2 2.4 9.6 1 12.1-3.2 2.4-4.2 1-9.6-3.2-12.1l-15.3-8.8c-4.2-2.4-9.6-1-12.1 3.2zM278.1 438.9c-4.2 2.4-9.6 1-12.1-3.2l-8.8-15.3c-2.4-4.2-1-9.6 3.2-12.1 4.2-2.4 9.6-1 12.1 3.2l8.8 15.3c2.4 4.3 1 9.7-3.2 12.1zM145.7 209.6c-4.2 2.4-9.6 1-12.1-3.2l-8.8-15.3c-2.4-4.2-1-9.6 3.2-12.1 4.2-2.4 9.6-1 12.1 3.2l8.8 15.3c2.4 4.2 1 9.6-3.2 12.1zM333 233.9c2.4 4.2 1 9.6-3.2 12.1l-15.3 8.8c-4.2 2.4-9.6 1-12.1-3.2-2.4-4.2-1-9.6 3.2-12.1l15.3-8.8c4.3-2.4 9.7-1 12.1 3.2zM103.6 366.3c2.4 4.2 1 9.6-3.2 12.1l-15.3 8.8c-4.2 2.4-9.6 1-12.1-3.2-2.4-4.2-1-9.6 3.2-12.1l15.3-8.8c4.3-2.4 9.7-1 12.1 3.2z"/></g><path class="racing-obj-4" d="M300.1 414.9c-2.3 0-4.5-.9-6.2-2.6L179.1 297.6c-3.4-3.4-3.4-9 0-12.5s9-3.4 12.5 0l114.8 114.8c3.4 3.4 3.4 9 0 12.5-1.7 1.6-4 2.5-6.3 2.5z"/><circle class="racing-obj-2" cx="203" cy="309" r="17.7"/></svg>'};

/***/ }),

/***/ 1250:
/***/ (function(module, exports) {

module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 176.4"><path class="glasses-obj-1" d="M303.7 46.3c1-2.1 6-9.6 30.3-16.9 27.3-8.3 63.6-11.9 91.2-11.9 19.1 0 34.1 1.7 39.1 4.8 13.4 8.2 19.2 57.5.9 100.2-15.6 36.4-97.9 40.1-119.6 33-10.5-3.5-24.5-21.4-34.2-43.6-11.2-25.6-14.2-51.4-7.7-65.6z"/><path class="glasses-obj-2" d="M447.6 140.3c18.3-42.8 12.5-92-.9-100.2-5-3.1-20-4.8-39.1-4.8-27.6 0-63.9 3.6-91.2 11.9-6 1.8-10.9 3.6-14.7 5.4.5-2.2 1.2-4.3 2-6.1 1-2.1 6-9.6 30.3-16.9 27.3-8.3 63.6-11.9 91.2-11.9 19.1 0 34.1 1.7 39.1 4.8 13.4 8.2 19.2 57.5.9 100.2-3.4 8-10.1 14.3-18.5 19.3.2-.6.6-1.1.9-1.7z"/><path class="glasses-obj-1" d="M200.7 112.2c-9.7 22.2-23.7 40.2-34.2 43.6-21.7 7.1-104 3.5-119.6-33-18.3-42.8-12.5-92 .9-100.2 5-3.1 20-4.8 39.1-4.8 27.6 0 63.9 3.6 91.2 11.9 24.2 7.3 29.3 14.8 30.3 16.9 6.5 14 3.5 39.8-7.7 65.6z"/><path class="glasses-obj-3" d="M503.2 8.7h-28.1c-.6-.4-1.1-.9-1.7-1.3-19.2-11.8-97.6-9.1-144.7 5.1-4.2 1.3-8.2 2.6-11.8 4-8.2 3.2-16.6 6-25.3 7.3-11 1.6-23 2.5-35.6 2.5-12.6 0-24.6-.9-35.6-2.5-8.7-1.3-17.1-4.1-25.3-7.3-3.6-1.4-7.5-2.8-11.8-4-47-14.2-125.4-17-144.7-5.2-.6.4-1.1.9-1.7 1.3H8.8C4 8.7 0 12.7 0 17.6v19.7c0 4.2 2.1 8.2 5.6 10.5l8.2 5.4c2.5 1.7 4 4.6 3.9 7.6-.7 21.7 3.6 46.5 13.1 68.8 15.4 35.9 68.7 46.8 107 46.8 14.7 0 27.2-1.6 34.4-4 18.6-6.2 35.4-31.6 44.8-53.3 8.1-18.6 12.3-36.8 12.5-52.5 0-3 1.5-5.8 4.1-7.4 6.1-3.9 13.9-6.3 22.5-6.3s16.5 2.4 22.5 6.3c2.6 1.6 4 4.4 4.1 7.4.2 15.7 4.4 33.9 12.5 52.5 9.5 21.7 26.2 47.2 44.8 53.3 7.2 2.4 19.7 4 34.4 4 38.2 0 91.6-10.8 107-46.8 9.5-22.3 13.8-47.1 13.1-68.8-.1-3.1 1.3-5.9 3.9-7.6l8.2-5.4c3.5-2.3 5.6-6.3 5.6-10.5V17.6c-.2-4.9-4.2-8.9-9-8.9zM200.7 112c-9.7 22.2-23.7 40.2-34.2 43.6-21.7 7.1-104 3.5-119.6-33-18.3-42.8-12.5-92 .9-100.2 5-3.1 20-4.8 39.1-4.8 27.6 0 63.9 3.6 91.2 11.9 24.2 7.3 29.3 14.8 30.3 16.9 6.5 14.1 3.5 39.9-7.7 65.6zM465 122.7c-15.6 36.5-97.9 40.1-119.6 33-10.5-3.5-24.5-21.4-34.2-43.6-11.2-25.8-14.2-51.6-7.7-65.7 1-2.1 6-9.6 30.3-16.9 46.2-14 118-14.6 130.3-7 13.4 8.2 19.2 57.4.9 100.2z"/><path class="glasses-obj-2" d="M64.5 140.3c-18.3-42.8-12.4-92 .9-100.3 5-3.1 20-4.8 39.1-4.8 27.6 0 63.9 3.6 91.2 11.9 6 1.8 10.9 3.6 14.7 5.4-.5-2.2-1.2-4.3-2-6.1-1-2.1-6-9.6-30.3-16.9-27.3-8.3-63.6-11.9-91.2-11.9-19.1 0-34.1 1.7-39.1 4.8-13.3 8.3-19.1 57.5-.8 100.3 3.4 8 10.1 14.3 18.5 19.3-.3-.6-.7-1.1-1-1.7z"/><circle class="glasses-obj-4" cx="145.7" cy="119.2" r="22.1"/><circle class="glasses-obj-4" cx="112.5" cy="86.1" r="11"/><circle class="glasses-obj-4" cx="406.1" cy="119.2" r="22.1"/><circle class="glasses-obj-4" cx="372.9" cy="86.1" r="11"/></svg>'};

/***/ }),

/***/ 1251:
/***/ (function(module, exports) {

module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 502.6 502.6"><path class="setting-obj-1" d="M337 141.1c-3.1-12.5-8.4-25.1-14.6-36.6l12.5-29.3L291 32.4l-29.3 12.5c-11.5-6.3-23-11.5-36.6-14.6L214.7 0h-61.6l-11.5 30.3c-12.5 3.1-25.1 8.4-36.6 14.6L75.8 32.4 32.9 75.2l12.5 29.3c-6.3 11.5-11.5 23-14.6 36.6L.5 152.6v61.6l30.3 11.5c3.1 12.5 8.4 25.1 14.6 36.6l-12.5 29.3 43.9 42.8 29.3-12.5c11.5 6.3 23 11.5 36.6 14.6l11.5 30.3h60.6l11.5-30.3c12.5-3.1 25.1-8.4 36.6-14.6l29.3 12.5 43.9-42.8-12.5-29.3c6.3-11.5 11.5-23 14.6-36.6l30.3-11.5v-61.6L337 141.1zm-153.6 117c-41.8 0-75.2-33.4-75.2-75.2s33.4-75.2 75.2-75.2 75.2 33.4 75.2 75.2-33.4 75.2-75.2 75.2z"/><path class="setting-obj-2" d="M236.7 236.1c-29.3 29.3-76.3 29.3-105.5 0L104 263.3c43.9 43.9 116 43.9 159.9 0s43.9-114.9 0-159.9l-27.2 27.2c29.2 29.3 29.2 76.3 0 105.5z"/><path class="setting-obj-2" d="M104 103.4c-43.9 43.9-43.9 114.9 0 159.9l27.2-27.2c-29.3-29.3-29.3-76.3 0-105.5s76.3-29.3 105.5 0l27.2-27.2c-43.9-43.8-116-43.8-159.9 0z"/><path class="setting-obj-1" d="M354.7 428.4c1-6.3 1-11.5 0-17.8l10.4-10.4-10.4-26.1h-14.6c-3.1-4.2-8.4-8.4-12.5-12.5V347l-26.1-10.4-10.5 10.3c-6.3-1-11.5-1-17.8 0l-10.4-10.4-26.1 10.4v14.6c-4.2 3.1-8.4 8.4-12.5 12.5h-14.6l-10.4 26.1 10.4 10.4c-1 6.3-1 11.5 0 17.8l-10.4 10.4 10.4 26.1h14.6c3.1 4.2 8.4 8.4 12.5 12.5v14.6l26.1 10.4 10.4-10.4c6.3 1 11.5 1 17.8 0l10.4 10.4 26.1-10.4v-14.6c4.2-3.1 8.4-8.4 12.5-12.5h14.6l10.4-26.1-10.3-10.3zm-83.5 22c-17.8-7.3-26.1-27.2-18.8-43.9 7.3-17.8 27.2-26.1 43.9-18.8 17.8 7.3 26.1 27.2 18.8 43.9-7.4 17.7-27.2 26.1-43.9 18.8z"/><path class="setting-obj-3" d="M491.6 291.5c1-6.3 1-11.5 0-17.8l10.4-10.4-10.4-26.1H477c-3.1-4.2-8.4-8.4-12.5-12.5V210l-26.1-10.4-10.5 10.4c-6.3-1-11.5-1-17.8 0l-10.4-10.4-26.1 10.4v14.6c-4.2 3.1-8.4 8.4-12.5 12.5h-14.6l-10.4 26.1 10.4 10.4c-1 6.3-1 11.5 0 17.8L335.9 302l10.4 26.1H361c3.1 4.2 8.4 8.4 12.5 12.5v14.6l26.1 10.4 10.4-10.4c6.3 1 11.5 1 17.8 0l10.4 10.4 26.1-10.4v-14.6c4.2-3.1 8.4-8.4 12.5-12.5h14.6l10.4-26.1-10.2-10.5zm-84.6 23c-17.8-7.3-26.1-27.2-18.8-43.9 7.3-17.8 27.2-26.1 43.9-18.8 17.8 7.3 26.1 27.2 18.8 43.9-6.3 17.8-26.1 26.1-43.9 18.8z"/></svg>'};

/***/ }),

/***/ 1252:
/***/ (function(module, exports) {

module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 58.184 58.184"><path d="M51.717 30.062a6.43 6.43 0 0 0-4.235 1.588l-1.811-1.243a18.659 18.659 0 0 0 2.167-8.749c0-10.354-8.392-18.747-18.747-18.747s-18.747 8.394-18.747 18.747c0 3.295.852 6.39 2.345 9.08l-1.706 1.169a6.464 6.464 0 1 0-4.518 11.084 6.464 6.464 0 0 0 6.193-8.315l1.837-1.259a18.704 18.704 0 0 0 12.98 6.913v2.225a6.46 6.46 0 0 0-4.848 6.253 6.465 6.465 0 0 0 12.93 0c0-3.011-2.062-5.534-4.848-6.253v-2.224a18.715 18.715 0 0 0 13.212-7.207l1.731 1.189a6.447 6.447 0 0 0-.398 2.214 6.465 6.465 0 1 0 6.463-6.465zM29.091 35.88c-7.842 0-14.222-6.38-14.222-14.222s6.38-14.222 14.222-14.222 14.222 6.38 14.222 14.222-6.38 14.222-14.222 14.222z"/><circle cx="29.09" cy="15.839" r="4.525"/><path d="M38.13 25.092c-.118-1.899-2.972-3.434-6.453-3.434h-5.172c-3.481 0-6.335 1.535-6.453 3.435l-.012 3.676h18.101l-.011-3.677z"/></svg>'};

/***/ }),

/***/ 1254:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(170);
module.exports = __webpack_require__(169);


/***/ }),

/***/ 166:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(24)(
  /* script */
  __webpack_require__(172),
  /* template */
  __webpack_require__(1234),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 167:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(24)(
  /* script */
  __webpack_require__(173),
  /* template */
  __webpack_require__(1236),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 168:
/***/ (function(module, exports) {

module.exports = {template: '<svg viewBox="0 0 214.9 62.3"><path class="tt-logo-path-1" d="M78.3 54.4v-5.2c0-.8-.2-1.4-.5-1.7-.3-.4-.8-.5-1.5-.5-.9 0-1.6.2-2.1.7-.4.5-.7 1.3-.7 2.3v4.4h-.7V43h.7v4.6h.1c.3-.5.7-.8 1.1-1 .4-.2 1-.3 1.7-.3 1.8 0 2.7 1 2.7 2.9v5.2h-.8zM90.7 50.4c0 1.3-.3 2.3-.9 3-.6.7-1.5 1.1-2.6 1.1-.7 0-1.3-.2-1.8-.5s-.9-.8-1.2-1.5c-.3-.6-.4-1.4-.4-2.2 0-1.3.3-2.3.9-3 .6-.7 1.5-1.1 2.6-1.1s1.9.4 2.5 1.1c.6.8.9 1.8.9 3.1zm-6.2 0c0 1.1.2 1.9.7 2.6.5.6 1.1.9 2 .9.9 0 1.5-.3 2-.9.5-.6.7-1.5.7-2.6s-.2-2-.7-2.6-1.2-.9-2-.9c-.9 0-1.5.3-2 .9-.5.6-.7 1.5-.7 2.6zM97.6 53.9c.5 0 .8 0 1.2-.1v.6c-.3.1-.7.2-1.2.2-.7 0-1.2-.2-1.5-.6-.3-.4-.5-1-.5-1.8v-5.1h-1.2v-.4l1.2-.3.4-1.8h.4v1.9h2.3v.6h-2.3v5c0 .6.1 1.1.3 1.4.1.2.5.4.9.4zM111.8 53.9c.5 0 .8 0 1.2-.1v.6c-.3.1-.8.2-1.2.2-.7 0-1.2-.2-1.5-.6-.3-.4-.5-1-.5-1.8v-5.1h-1.2v-.4l1.2-.3.4-1.8h.4v1.9h2.3v.6h-2.3v5c0 .6.1 1.1.3 1.4s.4.4.9.4zM122.1 54.4l-.2-1.3h-.1c-.4.5-.8.9-1.2 1.1-.4.2-.9.3-1.5.3-.8 0-1.4-.2-1.8-.6-.4-.4-.6-1-.6-1.7 0-.8.3-1.4 1-1.8s1.6-.7 2.8-.7h1.5v-.5c0-.8-.2-1.3-.5-1.7-.3-.4-.8-.6-1.5-.6s-1.5.2-2.3.6l-.3-.6c.9-.4 1.7-.6 2.6-.6.9 0 1.5.2 1.9.7.4.5.6 1.2.6 2.1v5.3h-.4zm-2.9-.5c.8 0 1.5-.2 2-.7.5-.5.7-1.2.7-2v-.8l-1.4.1c-1.1.1-1.9.2-2.4.5s-.7.8-.7 1.4c0 .5.2.9.5 1.2.3.1.8.3 1.3.3zM132.7 52.3c0 .7-.3 1.3-.8 1.6-.5.4-1.3.6-2.3.6-1.1 0-1.9-.2-2.5-.5v-.8c.8.4 1.6.6 2.5.6.8 0 1.4-.1 1.8-.4.4-.3.6-.6.6-1s-.2-.7-.5-1c-.3-.3-.8-.5-1.6-.8-.8-.3-1.3-.5-1.7-.7-.3-.2-.6-.4-.7-.7-.2-.3-.2-.6-.2-1 0-.6.2-1.1.7-1.4.5-.3 1.2-.5 2.1-.5.8 0 1.7.2 2.4.5l-.3.7c-.8-.3-1.5-.5-2.2-.5-.6 0-1.2.1-1.5.3-.4.2-.6.5-.6.9s.1.7.4 1 .9.5 1.7.8c.7.3 1.2.5 1.5.7.3.2.6.4.7.7.5.3.5.6.5.9zM138.1 50.9l4-4.5h.9l-3.1 3.4 3.4 4.6h-.9l-3-4-1.3 1.2v2.8h-.7V43h.7v7.9zM155.9 53.9c.5 0 .8 0 1.2-.1v.6c-.3.1-.7.2-1.2.2-.7 0-1.2-.2-1.5-.6-.3-.4-.5-1-.5-1.8v-5.1h-1.2v-.4l1.2-.3.4-1.8h.4v1.9h2.3v.6h-2.3v5c0 .6.1 1.1.3 1.4.1.2.4.4.9.4zM164.5 46.3c.3 0 .7 0 1.1.1l-.1.7c-.3-.1-.7-.1-1-.1-.7 0-1.2.3-1.7.9s-.6 1.3-.6 2.2v4.4h-.7v-8h.6l.1 1.4c.3-.6.7-1 1-1.2.4-.3.8-.4 1.3-.4zM174.7 54.4l-.2-1.3h-.1c-.4.5-.8.9-1.2 1.1-.4.2-.9.3-1.5.3-.8 0-1.4-.2-1.8-.6-.4-.4-.6-1-.6-1.7 0-.8.3-1.4 1-1.8s1.6-.7 2.8-.7h1.5v-.5c0-.8-.2-1.3-.5-1.7-.3-.4-.8-.6-1.5-.6s-1.5.2-2.3.6l-.3-.6c.9-.4 1.7-.6 2.6-.6.9 0 1.5.2 1.9.7.4.5.6 1.2.6 2.1v5.3h-.4zm-2.9-.5c.8 0 1.5-.2 2-.7.5-.5.7-1.2.7-2v-.8l-1.4.1c-1.1.1-1.9.2-2.4.5s-.7.8-.7 1.4c0 .5.2.9.5 1.2.3.1.7.3 1.3.3zM183.6 54.5c-1.1 0-2-.4-2.6-1.1-.6-.7-1-1.7-1-3s.3-2.3 1-3.1c.7-.7 1.6-1.1 2.7-1.1.7 0 1.3.1 2 .4l-.2.6c-.7-.2-1.3-.3-1.8-.3-1 0-1.7.3-2.2.9-.5.6-.7 1.5-.7 2.6s.2 1.9.7 2.5c.5.6 1.2.9 2.1.9.7 0 1.4-.1 2-.4v.7c-.6.3-1.2.4-2 .4zM190.8 50.9l4-4.5h.9l-3.1 3.4 3.4 4.6h-.9l-3-4-1.3 1.2v2.8h-.7V43h.7v7.9zM203.1 54.5c-1.1 0-2-.4-2.7-1.1s-1-1.7-1-3 .3-2.3.9-3c.6-.8 1.5-1.1 2.5-1.1.9 0 1.7.3 2.2 1 .5.7.8 1.5.8 2.7v.6h-5.7c0 1.1.3 1.9.8 2.5.5.6 1.2.9 2.1.9.4 0 .8 0 1.2-.1.3-.1.8-.2 1.3-.4v.5c-.4.2-.9.3-1.2.4-.3.1-.7.1-1.2.1zm-.2-7.6c-.8 0-1.4.3-1.8.8-.5.5-.7 1.2-.8 2.2h4.9c0-.9-.2-1.6-.6-2.2-.4-.5-1-.8-1.7-.8zM213.9 46.3c.3 0 .7 0 1.1.1l-.1.7c-.3-.1-.7-.1-1-.1-.7 0-1.2.3-1.7.9s-.6 1.3-.6 2.2v4.4h-.7v-8h.6l.1 1.4c.3-.6.7-1 1-1.2.3-.3.8-.4 1.3-.4z"/><g><path class="tt-logo-path-1" d="M91.1 38.3V25.9c0-1.5-1.2-3.2-2.7-3.2-1.4 0-3.7 1-5.1 1.9v13.7H72.7v-32h10.5v12.4c1.7-1.3 4.7-2.6 7.8-2.6 6.8 0 10.3 3.5 10.3 8.3v14H91.1zM119.4 38.8c-8.8 0-15.2-3.7-15.2-11.5 0-8.2 6.4-11.5 15.2-11.5 9.1 0 15.1 3.6 15.1 11.5 0 8.1-5.9 11.5-15.1 11.5zm0-15.5c-3.2 0-5 1.6-5 3.9 0 2.1 1.9 4 5 4 3.2 0 5.1-1.8 5.1-4 0-2.1-1.9-3.9-5.1-3.9zM161 35.1c-2.4 2.2-5.7 3.3-8.7 3.3-2.2 0-4.6-.5-6.8-1.6-2.5-1.6-4.6-4.7-4.6-7.1v-6.9h-3.8v-6.2h3.8v-3.8l10.7-3.5v7.3h9.1v6.2h-9.1v6c0 .8.2 1.3.6 1.6.3.2.7.3 1.3.3.4 0 3-.3 4.8-2.3l2.7 6.7zM187.8 35.1c-2.4 2.2-5.7 3.3-8.7 3.3-2.2 0-4.6-.5-6.8-1.6-2.5-1.6-4.6-4.7-4.6-7.1v-6.9h-3.8v-6.2h3.8v-3.8l10.7-3.5v7.3h9.1v6.2h-9.1v6c0 .8.2 1.3.6 1.6.3.2.7.3 1.3.3.4 0 3-.3 4.8-2.3l2.7 6.7zM214.5 35.1c-2.4 2.2-5.7 3.3-8.7 3.3-2.2 0-4.6-.5-6.8-1.6-2.5-1.6-4.6-4.7-4.6-7.1v-6.9h-3.8v-6.2h3.8v-3.8l10.7-3.5v7.3h9.1v6.2h-9.1v6c0 .8.2 1.3.6 1.6.3.2.7.3 1.3.3.4 0 3-.3 4.8-2.3l2.7 6.7z"/></g><g><path class="tt-logo-path-2" d="M43.2 49.4s-6.5 9.1-14.6 12.8c-1.8-2.7-2.9-4.4-3.5-7.7-8.9 3.8-20.5 4.4-20.5 4.4s.6-12.7 4.8-20.5c-3-.9-5.1-1.2-9.4-3 .3-1.1 5.3-9.9 13.3-15.2 1.6.6 29.9 29.2 29.9 29.2z"/><path class="tt-logo-path-3" d="M25 54.5c-.3-1.5-.6-3.1-.5-4-8.1 2.3-17.3 3.7-19.5 4-.3 2.6-.4 4.4-.4 4.4s11.5-.5 20.4-4.4zM28.5 62.3c8.2-3.7 14.6-12.9 14.6-12.9s-1.1-1.1-3-3.1c-.6.3-.9.7-1 1-1.3 3.5-8.6 9.6-12.5 12 .6 1 1.2 1.9 1.9 3zM1.4 32.7C.5 34.1 0 35.1 0 35.4c4.2 1.8 6.4 2.1 9.4 3l2.8-2.9-10.8-2.8z"/><ellipse class="tt-logo-path-2" cx="37.7" cy="25" rx="25.3" ry="25"/><path class="tt-logo-path-3" d="M61.1 21.2c0 13.6-11 24.5-24.5 24.5-11.9 0-21.9-8.5-24.1-19.8.5 13.4 11.6 24.2 25.2 24.2 14 0 25.3-11.2 25.3-25 0-4.7-1.3-9-3.5-12.7 1.1 2.6 1.6 5.6 1.6 8.8z"/><ellipse class="tt-logo-path-4" cx="37.7" cy="25" rx="17.8" ry="17.6"/><path class="tt-logo-path-5" d="M50.9 13.2c1.4 2.4 2.2 5.3 2.2 8.3 0 9.4-7.6 17-17 17-7.1 0-13.2-4.3-15.7-10.5 1.4 8.3 8.7 14.6 17.5 14.6 9.8 0 17.8-7.9 17.8-17.6-.2-4.6-2-8.7-4.8-11.8z"/><path class="tt-logo-path-6" d="M48.8 26.9c-1.1 0-2-.9-2-2 0-5.4-4.5-9.1-11.1-9.1-1.1 0-2-.9-2-2s.9-2 2-2c8.7 0 15.1 5.5 15.1 13.1 0 1.1-.9 2-2 2z"/></g></svg>'};

/***/ }),

/***/ 169:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_uiv__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_awesome_icons_flag__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_awesome_icons__ = __webpack_require__(810);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_awesome_components_Icon__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_awesome_components_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_awesome_components_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_affix__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_affix___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_affix__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_scrollactive__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_scrollactive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_scrollactive__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_scss_app_scss__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_scss_app_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_scss_app_scss__);













__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('icon', __WEBPACK_IMPORTED_MODULE_7_vue_awesome_components_Icon___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_uiv__);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8_vue_affix___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_9_vue_scrollactive___default.a);


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* store */],
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  created: function created() {
    window.vue = this;
  },

  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),

/***/ 171:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var icons = {};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'icon',
  props: {
    name: {
      type: String,
      validator: function validator(val) {
        if (val) {
          if (!(val in icons)) {
            console.warn('Invalid prop: prop "name" is referring to an unregistered icon "' + val + '".' + '\nPlesase make sure you have imported this icon before using it.');
            return false;
          }
          return true;
        }
        console.warn('Invalid prop: prop "name" is required.');
        return false;
      }
    },
    scale: [Number, String],
    spin: Boolean,
    inverse: Boolean,
    pulse: Boolean,
    flip: {
      validator: function validator(val) {
        return val === 'horizontal' || val === 'vertical';
      }
    },
    label: String
  },
  data: function data() {
    return {
      x: false,
      y: false,
      childrenWidth: 0,
      childrenHeight: 0,
      outerScale: 1
    };
  },

  computed: {
    normalizedScale: function normalizedScale() {
      var scale = this.scale;
      scale = typeof scale === 'undefined' ? 1 : Number(scale);
      if (isNaN(scale) || scale <= 0) {
        console.warn('Invalid prop: prop "scale" should be a number over 0.', this);
        return this.outerScale;
      }
      return scale * this.outerScale;
    },
    klass: function klass() {
      return {
        'fa-icon': true,
        'fa-spin': this.spin,
        'fa-flip-horizontal': this.flip === 'horizontal',
        'fa-flip-vertical': this.flip === 'vertical',
        'fa-inverse': this.inverse,
        'fa-pulse': this.pulse
      };
    },
    icon: function icon() {
      if (this.name) {
        return icons[this.name];
      }
      return null;
    },
    box: function box() {
      if (this.icon) {
        return '0 0 ' + this.icon.width + ' ' + this.icon.height;
      }
      return '0 0 ' + this.width + ' ' + this.height;
    },
    ratio: function ratio() {
      if (!this.icon) {
        return 1;
      }
      var _icon = this.icon,
          width = _icon.width,
          height = _icon.height;

      return Math.max(width, height) / 16;
    },
    width: function width() {
      return this.childrenWidth || this.icon && this.icon.width / this.ratio * this.normalizedScale || 0;
    },
    height: function height() {
      return this.childrenHeight || this.icon && this.icon.height / this.ratio * this.normalizedScale || 0;
    },
    style: function style() {
      if (this.normalizedScale === 1) {
        return false;
      }
      return {
        fontSize: this.normalizedScale + 'em'
      };
    },
    raw: function raw() {
      // generate unique id for each icon's SVG element with ID
      if (!this.icon || !this.icon.raw) {
        return null;
      }
      var raw = this.icon.raw;
      var ids = {};
      raw = raw.replace(/\s(?:xml:)?id=["']?([^"')\s]+)/g, function (match, id) {
        var uniqueId = getId();
        ids[id] = uniqueId;
        return ' id="' + uniqueId + '"';
      });
      raw = raw.replace(/#(?:([^'")\s]+)|xpointer\(id\((['"]?)([^')]+)\2\)\))/g, function (match, rawId, _, pointerId) {
        var id = rawId || pointerId;
        if (!id || !ids[id]) {
          return match;
        }

        return '#' + ids[id];
      });

      return raw;
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.icon) {
      return;
    }
    this.$children.forEach(function (child) {
      child.outerScale = _this.normalizedScale;
    });
    var width = 0;
    var height = 0;
    this.$children.forEach(function (child) {
      width = Math.max(width, child.width);
      height = Math.max(height, child.height);
    });
    this.childrenWidth = width;
    this.childrenHeight = height;
    this.$children.forEach(function (child) {
      child.x = (width - child.width) / 2;
      child.y = (height - child.height) / 2;
    });
  },
  register: function register(data) {
    for (var name in data) {
      var icon = data[name];

      if (!icon.paths) {
        icon.paths = [];
      }
      if (icon.d) {
        icon.paths.push({ d: icon.d });
      }

      if (!icon.polygons) {
        icon.polygons = [];
      }
      if (icon.points) {
        icon.polygons.push({ points: icon.points });
      }

      icons[name] = icon;
    }
  },

  icons: icons
});

var cursor = 0xd4937;
function getId() {
  return 'fa-' + (cursor++).toString(16);
}

/***/ }),

/***/ 172:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
//
//
//
//
//




// Check if request comes from browser and is not server rendered
if (typeof window !== 'undefined') {
  var slick = __webpack_require__(428);
}

/* harmony default export */ __webpack_exports__["default"] = ({

  props: {
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },

  mounted: function mounted() {
    this.create();
  },
  destroyed: function destroyed() {
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el).slick('unslick');
  },


  methods: {
    create: function create() {
      var $slick = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el);

      $slick.on('afterChange', this.onAfterChange);
      $slick.on('beforeChange', this.onBeforeChange);
      $slick.on('breakpoint', this.onBreakpoint);
      $slick.on('destroy', this.onDestroy);
      $slick.on('edge', this.onEdge);
      $slick.on('init', this.onInit);
      $slick.on('reInit', this.onReInit);
      $slick.on('setPosition', this.onSetPosition);
      $slick.on('swipe', this.onSwipe);
      $slick.on('lazyLoaded', this.onLazyLoaded);
      $slick.on('lazyLoadError', this.onLazyLoadError);

      $slick.slick(this.options);
    },
    destroy: function destroy() {
      var $slick = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el);

      $slick.off('afterChange', this.onAfterChange);
      $slick.off('beforeChange', this.onBeforeChange);
      $slick.off('breakpoint', this.onBreakpoint);
      $slick.off('destroy', this.onDestroy);
      $slick.off('edge', this.onEdge);
      $slick.off('init', this.onInit);
      $slick.off('reInit', this.onReInit);
      $slick.off('setPosition', this.onSetPosition);
      $slick.off('swipe', this.onSwipe);
      $slick.off('lazyLoaded', this.onLazyLoaded);
      $slick.off('lazyLoadError', this.onLazyLoadError);
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el).slick('unslick');
    },
    reSlick: function reSlick() {
      this.destroy();
      this.create();
    },
    next: function next() {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el).slick('slickNext');
    },
    prev: function prev() {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el).slick('slickPrev');
    },
    pause: function pause() {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el).slick('slickPause');
    },
    play: function play() {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el).slick('slickPlay');
    },
    goTo: function goTo(index, dontAnimate) {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el).slick('slickGoTo', index, dontAnimate);
    },
    currentSlide: function currentSlide() {
      return __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el).slick('slickCurrentSlide');
    },
    add: function add(element, index, addBefore) {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el).slick('slickAdd', element, index, addBefore);
    },
    remove: function remove(index, removeBefore) {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el).slick('slickRemove', index, removeBefore);
    },
    filter: function filter(filterData) {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el).slick('slickFilter', filterData);
    },
    unfilter: function unfilter() {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el).slick('slickUnfilter');
    },
    getOption: function getOption(option) {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el).slick('slickGetOption', option);
    },
    setOption: function setOption(option, value, refresh) {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el).slick('slickSetOption', option, value, refresh);
    },
    setPosition: function setPosition() {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el).slick('setPosition');
    },


    // Events
    onAfterChange: function onAfterChange(event, slick, currentSlide) {
      this.$emit('afterChange', event, slick, currentSlide);
    },
    onBeforeChange: function onBeforeChange(event, slick, currentSlide, nextSlide) {
      this.$emit('beforeChange', event, slick, currentSlide, nextSlide);
    },
    onBreakpoint: function onBreakpoint(event, slick, breakpoint) {
      this.$emit('breakpoint', event, slick, breakpoint);
    },
    onDestroy: function onDestroy(event, slick) {
      this.$emit('destroy', event, slick);
    },
    onEdge: function onEdge(event, slick, direction) {
      this.$emit('edge', event, slick, direction);
    },
    onInit: function onInit(event, slick) {
      this.$emit('init', event, slick);
    },
    onReInit: function onReInit(event, slick) {
      this.$emit('reInit', event, slick);
    },
    onSetPosition: function onSetPosition(event, slick) {
      this.$emit('setPosition', event, slick);
    },
    onSwipe: function onSwipe(event, slick, direction) {
      this.$emit('swipe', event, slick, direction);
    },
    onLazyLoaded: function onLazyLoaded(event, slick, image, imageSource) {
      this.$emit('lazyLoaded', event, slick, image, imageSource);
    },
    onLazyLoadError: function onLazyLoadError(event, slick, image, imageSource) {
      this.$emit('lazyLoadError', event, slick, image, imageSource);
    }
  }

});

/***/ }),

/***/ 173:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_Header__ = __webpack_require__(1224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_Header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_common_Header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_Advantages__ = __webpack_require__(1218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_Advantages___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_common_Advantages__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_Overview__ = __webpack_require__(1225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_Overview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_common_Overview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_Gallery__ = __webpack_require__(1223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_Gallery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_common_Gallery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_CallToAction__ = __webpack_require__(1219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_CallToAction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_common_CallToAction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common_Donate__ = __webpack_require__(1221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common_Donate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_common_Donate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_common_Contacts__ = __webpack_require__(1220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_common_Contacts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_common_Contacts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_common_Footer__ = __webpack_require__(1222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_common_Footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_common_Footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_jquery__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_jquery_nicescroll__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_jquery_nicescroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_jquery_nicescroll__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'app',
    components: {
        Header: __WEBPACK_IMPORTED_MODULE_0__components_common_Header___default.a,
        Advantages: __WEBPACK_IMPORTED_MODULE_1__components_common_Advantages___default.a,
        Overview: __WEBPACK_IMPORTED_MODULE_2__components_common_Overview___default.a,
        Gallery: __WEBPACK_IMPORTED_MODULE_3__components_common_Gallery___default.a,
        CallToAction: __WEBPACK_IMPORTED_MODULE_4__components_common_CallToAction___default.a,
        Donate: __WEBPACK_IMPORTED_MODULE_5__components_common_Donate___default.a,
        Contacts: __WEBPACK_IMPORTED_MODULE_6__components_common_Contacts___default.a,
        Footer: __WEBPACK_IMPORTED_MODULE_7__components_common_Footer___default.a
    },
    data: function data() {
        return {};
    },
    created: function created() {
        __WEBPACK_IMPORTED_MODULE_8_jquery___default()('html').niceScroll({
            cursorcolor: '#777',
            cursoropacitymax: 0.7,
            cursorwidth: '9',
            cursorborder: 'none',
            cursorborderradius: '10px',
            background: '#ccc',
            zindex: '9999999',
            touchbehavior: false,
            //                horizrailenabled: false,
            scrollspeed: '120'
        });
    },

    methods: {
        updateAnimations: function updateAnimations() {
            window.addEventListener("scroll", function () {
                var $elems = __WEBPACK_IMPORTED_MODULE_8_jquery___default()('.animateblock'),
                    windowHeight = __WEBPACK_IMPORTED_MODULE_8_jquery___default()(window).height(),
                    fullHeight = __WEBPACK_IMPORTED_MODULE_8_jquery___default()(document).height(),
                    windowTop = __WEBPACK_IMPORTED_MODULE_8_jquery___default()(window).scrollTop(); // calculate distance from top of window

                // loop through each item to check when it animates
                $elems.each(function () {
                    var $elm = __WEBPACK_IMPORTED_MODULE_8_jquery___default()(this);

                    if ($elm.hasClass('animated')) {
                        return true;
                    } // if already animated skip to the next item

                    var topCoords = $elm.offset().top; // element's distance from top of page in pixels

                    function getWidth() {
                        return window.innerWidth / 14; // for responsive circles
                    }

                    if (windowTop > topCoords - windowHeight * 0.7) {
                        // animate when top of the window is 3/4 above the element
                        $elm.addClass('animated');
                    }
                });
            });

            __WEBPACK_IMPORTED_MODULE_8_jquery___default()('.parallax').each(function () {
                var $obj = __WEBPACK_IMPORTED_MODULE_8_jquery___default()(this),
                    yPos = __WEBPACK_IMPORTED_MODULE_8_jquery___default()(window).scrollTop() / $obj.data('speed') / 2,
                    bgPos = yPos + 'px';
                $obj.css('top', bgPos);
            });
        }
    },
    mounted: function mounted() {
        this.updateAnimations();
    }
});

/***/ }),

/***/ 174:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_slick__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_slick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_slick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_svg_atom_svg__ = __webpack_require__(1246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_svg_atom_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_svg_atom_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_svg_racing_svg__ = __webpack_require__(1249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_svg_racing_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_svg_racing_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_svg_reading_glasses_svg__ = __webpack_require__(1250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_svg_reading_glasses_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_svg_reading_glasses_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_svg_analytics_svg__ = __webpack_require__(1245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_svg_analytics_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_svg_analytics_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_svg_chat_svg__ = __webpack_require__(1247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_svg_chat_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_svg_chat_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_svg_settings_svg__ = __webpack_require__(1251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_svg_settings_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_svg_settings_svg__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
    name: "Advantages",
    components: {
        Slick: __WEBPACK_IMPORTED_MODULE_0_vue_slick___default.a,
        Atom: __WEBPACK_IMPORTED_MODULE_1__assets_svg_atom_svg___default.a,
        Racing: __WEBPACK_IMPORTED_MODULE_2__assets_svg_racing_svg___default.a,
        ReadingGlasses: __WEBPACK_IMPORTED_MODULE_3__assets_svg_reading_glasses_svg___default.a,
        Analytics: __WEBPACK_IMPORTED_MODULE_4__assets_svg_analytics_svg___default.a,
        Chat: __WEBPACK_IMPORTED_MODULE_5__assets_svg_chat_svg___default.a,
        Settings: __WEBPACK_IMPORTED_MODULE_6__assets_svg_settings_svg___default.a
    },
    data: function data() {
        return {
            slickOptions: {
                slidesToShow: 3,
                slidesToScroll: 3,
                dots: true,
                responsive: [{
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                }, {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }]
            }
        };
    }
});

/***/ }),

/***/ 175:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: "CallToAction",
    data: function data() {
        return {};
    }
});

/***/ }),

/***/ 176:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: "Contacts",
    data: function data() {
        return {};
    }
});

/***/ }),

/***/ 177:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: "Donate",
    data: function data() {
        return {};
    }
});

/***/ }),

/***/ 178:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_svg_tt_logo5_text_svg__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_svg_tt_logo5_text_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_svg_tt_logo5_text_svg__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    name: "Footer",
    components: {
        FooterLogo: __WEBPACK_IMPORTED_MODULE_0__assets_svg_tt_logo5_text_svg___default.a
    }

});

/***/ }),

/***/ 179:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_slick__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_slick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_slick__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    name: "Gallery",
    components: {
        Slick: __WEBPACK_IMPORTED_MODULE_0_vue_slick___default.a
    },
    data: function data() {
        return {
            slickOptions: {
                slidesToShow: 3,
                centerMode: true,
                centerPadding: '0',
                infinite: false,
                initialSlide: 3,
                slidesPerRow: 1,
                speed: 300,
                responsive: [{
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        centerMode: false
                    }
                }]
            }
        };
    }
});

/***/ }),

/***/ 180:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_svg_tt_logo5_text_svg__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_svg_tt_logo5_text_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_svg_tt_logo5_text_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_svg_g_svg__ = __webpack_require__(1248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_svg_g_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_svg_g_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Header',
    components: {
        HeaderLogo: __WEBPACK_IMPORTED_MODULE_0__assets_svg_tt_logo5_text_svg___default.a,
        GPlus: __WEBPACK_IMPORTED_MODULE_1__assets_svg_g_svg___default.a
    },
    data: function data() {
        return {
            openMenu: false
        };
    },
    mounted: function mounted() {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.navbar-toggle').on('click', function () {
            __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.navbar-collapse').slideToggle();
        });
    }
});

/***/ }),

/***/ 181:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_svg_user_svg__ = __webpack_require__(1252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_svg_user_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_svg_user_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_svg_061_file_5_svg__ = __webpack_require__(1241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_svg_061_file_5_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_svg_061_file_5_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_svg_008_chat_3_svg__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_svg_008_chat_3_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_svg_008_chat_3_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_svg_094_padlock_svg__ = __webpack_require__(1242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_svg_094_padlock_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_svg_094_padlock_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_svg_111_file_svg__ = __webpack_require__(1244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_svg_111_file_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_svg_111_file_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_svg_096_analytics_svg__ = __webpack_require__(1243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_svg_096_analytics_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_svg_096_analytics_svg__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
    name: "Overview",
    components: {
        User: __WEBPACK_IMPORTED_MODULE_0__assets_svg_user_svg___default.a,
        File: __WEBPACK_IMPORTED_MODULE_1__assets_svg_061_file_5_svg___default.a,
        Chat: __WEBPACK_IMPORTED_MODULE_2__assets_svg_008_chat_3_svg___default.a,
        Block: __WEBPACK_IMPORTED_MODULE_3__assets_svg_094_padlock_svg___default.a,
        Doc: __WEBPACK_IMPORTED_MODULE_4__assets_svg_111_file_svg___default.a,
        Search: __WEBPACK_IMPORTED_MODULE_5__assets_svg_096_analytics_svg___default.a
    },
    data: function data() {
        return {};
    }
});

/***/ }),

/***/ 182:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(1237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);



var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  linkActiveClass: 'active',
  routes: [{
    path: '/',
    name: 'Index',
    component: __WEBPACK_IMPORTED_MODULE_2__App___default.a
  }]
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 183:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GET_SOCIAL_URL", function() { return GET_SOCIAL_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOGOUT", function() { return LOGOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SOCIAL_LOGIN", function() { return SOCIAL_LOGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GET_USER", function() { return GET_USER; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(53);


var URL_ROOT = '/api';

var GET_SOCIAL_URL = function GET_SOCIAL_URL(_ref) {
  var commit = _ref.commit,
      state = _ref.state;

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].http.get(URL_ROOT + '/auth/social-url').then(function (response) {
      resolve();
    }, function () {
      reject();
    });
  });
};

var LOGOUT = function LOGOUT(_ref2) {
  var commit = _ref2.commit,
      state = _ref2.state;

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].http.get(URL_ROOT + '/auth/logout').then(function () {
      resolve();
    }, function () {
      reject();
    });
  });
};

var SOCIAL_LOGIN = function SOCIAL_LOGIN(_ref3, sn) {
  var commit = _ref3.commit,
      state = _ref3.state;

  var url = state.url[sn];

  var screenX = typeof window.screenX !== 'undefined' ? window.screenX : window.screenLeft;
  var screenY = typeof window.screenY !== 'undefined' ? window.screenY : window.screenTop;
  var outerWidth = typeof window.outerWidth !== 'undefined' ? window.outerWidth : document.body.clientWidth;
  var outerHeight = typeof window.outerHeight !== 'undefined' ? window.outerHeight : document.body.clientHeight - 22;
  var width = 800;
  var height = 600;
  var left = parseInt(screenX + (outerWidth - width) / 2, 10);
  var top = parseInt(screenY + (outerHeight - height) / 2.5, 10);
  var features = 'width=' + width + ',height=' + height + ',left=' + left + ',top=' + top;

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var win = window.open(url, "_blank", features);

    var watch_timer = setInterval(function () {
      try {
        if (win.closed) {
          clearInterval(watch_timer);
          GET_USER().then(function (response) {
            resolve();
          }, function () {
            reject();
          });
        }
      } catch (e) {
        reject();
      }
    }, 200);
  });
};

var GET_USER = function GET_USER(_ref4) {
  var commit = _ref4.commit,
      state = _ref4.state;

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].http.get(URL_ROOT + '/user').then(function (response) {
      resolve();
    }, function () {
      reject();
    });
  });
};

/***/ }),

/***/ 184:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GET_CURRENT_ID", function() { return GET_CURRENT_ID; });

var GET_CURRENT_ID = function GET_CURRENT_ID(state) {
  return state.currentId;
};

/***/ }),

/***/ 185:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getters__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutations__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions__ = __webpack_require__(183);







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: __WEBPACK_IMPORTED_MODULE_2__state__["a" /* state */],
  actions: __WEBPACK_IMPORTED_MODULE_5__actions__,
  getters: __WEBPACK_IMPORTED_MODULE_3__getters__,
  mutations: __WEBPACK_IMPORTED_MODULE_4__mutations__
});

/***/ }),

/***/ 186:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_ID", function() { return UPDATE_ID; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_js__ = __webpack_require__(116);


var UPDATE_ID = function UPDATE_ID(State, id) {
    State.currentId = parseInt(id);
};

/***/ }),

/***/ 423:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 424:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[1254]);


// WEBPACK FOOTER //
// landing/static/js/app.js